/**
 * Shared SSE event parser.
 *
 * Extracted from useCloneProgress and the email notification stream, which had
 * near-identical parseSSEEvents implementations.
 */

export interface SSEEvent {
  eventType: string;
  data: string;
}

/**
 * Parse raw SSE text buffer into discrete events.
 * Returns parsed events and any remaining incomplete buffer text.
 */
export function parseSSEEvents(buffer: string): { events: SSEEvent[]; remaining: string } {
  const parts = buffer.split('\n\n');
  const remaining = parts.pop() ?? '';
  const events: SSEEvent[] = [];

  for (const eventBlock of parts) {
    if (!eventBlock.trim() || eventBlock.startsWith(':')) continue;

    const lines = eventBlock.split('\n');
    let eventType = '';
    let data = '';

    for (const line of lines) {
      if (line.startsWith('event:')) {
        eventType = line.slice(6).trim();
      } else if (line.startsWith('data:')) {
        data = line.slice(5).trim();
      }
    }

    if (eventType) {
      events.push({ eventType, data });
    }
  }

  return { events, remaining };
}
